<h2 style="margin-top:20vh; text-align:center;">
    {{ 'common.pageError.notFound.text'|translate }}
</h2>
